/**
 * Reads the `next` query parameter and returns a safe, same-origin relative path.
 * Used so sign-in returns the user to where they started (e.g. an app-connection
 * approval screen) instead of dropping them on the dashboard.
 */
export const getSafeNextPath = (search: string = window.location.search): string | null => {
  const raw = new URLSearchParams(search).get("next");
  if (!raw) return null;
  // Only same-origin relative paths; reject "//host" and absolute URLs.
  if (!raw.startsWith("/") || raw.startsWith("//")) return null;
  return raw;
};

export const nextAwareRedirectUrl = (fallbackPath = "/"): string => {
  const next = getSafeNextPath();
  return `${window.location.origin}${next ?? fallbackPath}`;
};
